<template>
  <a-drawer
    :title="detail && detail.name"
    width="1200"
    :visible="visible"
    :closable="false"
    :footer="false"
    @close="onClose"
  >
    <div class="tool-view">
      <!-- 弹簧 -->
      <div style="flex: 1;"></div>
      <!-- 音效文件 -->
      <a-button :disabled="isLoading" @click="touchSoundEffectConfig" style="margin-right: 10px;">音效文件</a-button>
      <!-- 视频操作 -->
      <a-dropdown :disabled="isLoading">
        <a-button>视频操作 <DownOutlined /></a-button>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <Upload
                accept=".mp4"
                uploadSource="MediaManagementBatch"
                :multiple="true"
                :disabled="isLoading"
                :fileList="batchFileList"
                :uploadBucket="$pub.BUCKET_YOUTUBE()"
                :beforeUploadPro="(file, fileList) => beforeUploadBatchPro(file, fileList, YoutubeVideoTypeObject.full)"
                style="display: inline-block;"
                @click="touchBatchUpload"
              >
                <template #up-slot>上传完整版本</template>
              </Upload>
            </a-menu-item>
            <a-menu-item>
              <Upload
                accept=".mp4"
                uploadSource="MediaManagementBatch"
                :multiple="true"
                :disabled="isLoading"
                :fileList="batchFileList"
                :uploadBucket="$pub.BUCKET_YOUTUBE()"
                :beforeUploadPro="(file, fileList) => beforeUploadBatchPro(file, fileList, YoutubeVideoTypeObject.no_bgm)"
                style="display: inline-block;"
                @click="touchBatchUpload"
              >
                <template #up-slot>上传无BGM版</template>
              </Upload>
            </a-menu-item>
            <a-menu-item>
              <Upload
                accept=".mp4"
                uploadSource="MediaManagementBatch"
                :multiple="true"
                :disabled="isLoading"
                :fileList="batchFileList"
                :uploadBucket="$pub.BUCKET_YOUTUBE()"
                :beforeUploadPro="(file, fileList) => beforeUploadBatchPro(file, fileList, YoutubeVideoTypeObject.no_subtitle)"
                style="display: inline-block;"
                @click="touchBatchUpload"
              >
                <template #up-slot>上传无字幕版</template>
              </Upload>
            </a-menu-item>
            <a-menu-item @click="touchImportFromApp">从APP片库导入</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
      <!-- 字幕操作 -->
      <!-- <a-dropdown :disabled="isLoading">
        <a-button style="margin-left: 10px;">字幕操作 <DownOutlined /></a-button>
        <template #overlay>
          <a-menu>
            <a-menu-item>
              <Upload
                accept=".mp4"
                uploadSource="MediaManagementBatch"
                :multiple="true"
                :disabled="isLoading"
                :fileList="batchFileList"
                :uploadBucket="$pub.BUCKET_YOUTUBE()"
                :beforeUploadPro="(file, fileList) => beforeUploadBatchPro(file, fileList, YoutubeVideoTypeObject.full)"
                style="display: inline-block;"
                @click="touchBatchUpload"
              >
                <template #up-slot>上传字幕</template>
              </Upload>
            </a-menu-item>
            <a-menu-item @click="touchHardSubtitle">提取硬字幕</a-menu-item>
          </a-menu>
        </template>
      </a-dropdown> -->
    </div>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="false"
      :loading="isLoading"
      @change="handleTableChange"
    >
      <!-- 自定义表头 -->
      <template #headerCell="{ column }">
        <template v-if="column.key === 'ad_type'">
          广告（{{ adTotal }}个）
        </template>
        <template v-else>
          {{ column.title }}
        </template>
      </template>
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 广告类型 -->
        <template v-if="column.key === 'ad_type'">
          <!-- {{ record[column.key] == 1 ? '是' : '' }} -->
          <a-switch
            v-model:checked="record.ad_type"
            checked-children="开"
            un-checked-children="关"
            @change="statusChange($event, record)"
          />
        </template>
        <!-- 完整版本 -->
        <template v-else-if="column.key == YoutubeVideoTypeObject.full">
          <div style="max-width: 100px;">
              <a @click="touchPreview(record, YoutubeVideoTypeObject.full)" v-if="record.video_types && record.video_types[column.key] && record.video_types[column.key].url">{{ record.video_types[column.key].name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 无BGM版本 -->
        <template v-else-if="column.key == YoutubeVideoTypeObject.no_bgm">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, YoutubeVideoTypeObject.no_bgm)" v-if="record.video_types && record.video_types[column.key] && record.video_types[column.key].url">{{ record.video_types[column.key].name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 无字幕版本 -->
        <template v-else-if="column.key == YoutubeVideoTypeObject.no_subtitle">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, YoutubeVideoTypeObject.no_subtitle)" v-if="record.video_types && record.video_types[column.key] && record.video_types[column.key].url">{{ record.video_types[column.key].name }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 原版字幕 -->
        <template v-else-if="column.key == 'original_subtitle'">
          <div style="max-width: 100px;">
            <a @click="touchPreview(record, YoutubeVideoTypeObject.original_subtitle)" v-if="record.original_subtitle">{{ record.original_subtitle }}</a>
            <span v-else>未上传</span>
          </div>
        </template>
        <!-- 操作 -->
        <template v-else-if="column.key === 'operation'">
          <!-- 视频操作 -->
          <a-dropdown>
            <a>视频操作 <DownOutlined /></a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <Upload
                    accept=".mp4"
                    uploadSource="MediaManagement"
                    :disabled="isLoading"
                    :uploadBucket="$pub.BUCKET_YOUTUBE()"
                    :beforeUploadPro="beforeUploadPro"
                    :uploadResult="(fileJson, res) => { uploadResult(fileJson, res, record, YoutubeVideoTypeObject.full) }"
                    style="display: inline-block;"
                  >
                    <template #up-slot>替换完整版本</template>
                  </Upload>
                </a-menu-item>
                <a-menu-item>
                  <Upload
                    accept=".mp4"
                    uploadSource="MediaManagement"
                    :disabled="isLoading"
                    :uploadBucket="$pub.BUCKET_YOUTUBE()"
                    :beforeUploadPro="beforeUploadPro"
                    :uploadResult="(fileJson, res) => { uploadResult(fileJson, res, record, YoutubeVideoTypeObject.no_bgm) }"
                    style="display: inline-block;"
                  >
                    <template #up-slot>替换无BGM版</template>
                  </Upload>
                </a-menu-item>
                <a-menu-item>
                  <Upload
                    accept=".mp4"
                    uploadSource="MediaManagement"
                    :uploadBucket="$pub.BUCKET_YOUTUBE()"
                    :beforeUploadPro="beforeUploadPro"
                    :uploadResult="(fileJson, res) => { uploadResult(fileJson, res, record, YoutubeVideoTypeObject.no_subtitle) }"
                    style="display: inline-block;"
                  >
                    <template #up-slot>替换无字幕版</template>
                  </Upload>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
          <!-- 字幕操作 -->
          <!-- <a-dropdown>
            <a style="margin-left: 10px;">字幕操作 <DownOutlined /></a>
            <template #overlay>
              <a-menu>
                <a-menu-item>
                  <Upload
                    accept=".mp4"
                    uploadSource="MediaManagementBatch"
                    :multiple="true"
                    :disabled="isLoading"
                    :fileList="batchFileList"
                    :uploadBucket="$pub.BUCKET_YOUTUBE()"
                    :beforeUploadPro="(file, fileList) => beforeUploadBatchPro(file, fileList, YoutubeVideoTypeObject.full)"
                    style="display: inline-block;"
                    @click="touchBatchUpload"
                  >
                    <template #up-slot>替换字幕</template>
                  </Upload>
                </a-menu-item>
                <a-menu-item @click="touchHardSubtitle">提取硬字幕</a-menu-item>
              </a-menu>
            </template>
          </a-dropdown> -->
        </template>
        <template v-else>
          {{ record[column.key] || '-' }}
        </template>
      </template>
    </a-table>
    <!-- 预览 -->
    <PreviewVideoProModal ref="RefPreviewModal"></PreviewVideoProModal>
    <!-- 加载 -->
    <Loading :loading="isSyncAllLoading"></Loading>
    <!-- 从APP片库导入 -->
    <ImportFromApp ref="RefImportFromApp" @success="getYtVideoList"></ImportFromApp>
    <!-- 音效文件 -->
    <SoundEffectConfig ref="RefSoundEffectConfig"></SoundEffectConfig>
  </a-drawer>
</template>

<script setup>
import { Modal } from 'ant-design-vue'
import { QuestionCircleOutlined } from '@ant-design/icons-vue'
import Pub from '@/utils/public'
import { onBeforeMount, reactive, ref, createVNode } from 'vue'
import { nextTick } from 'process'
import Upload from '@/components/Upload'
import PreviewVideoProModal from '@/components/preview/PreviewVideoProModal'
import { message } from 'ant-design-vue'
import { YoutubeVideoTypeObject } from '@/utils/constantList'
import { ytVideoList, ytVideoUpload, ytExistVideo } from '@/api/admin'
import { uploadCustom } from '@/utils/upload'
import Loading from '@/components/Loading'
import ImportFromApp from './ImportFromApp.vue'
import SoundEffectConfig from './SoundEffectConfig.vue'

// 视频预览
let RefPreviewModal = ref(null)
// 从APP片库导入
let RefImportFromApp = ref(null)
// 音效文件
let RefSoundEffectConfig = ref(null)
// 短剧信息
let detail = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
let isSyncAllLoading = ref(false)
// 批量上传列表
let batchFileList = ref([])
// 每轮批量上传ID
let batchUploadId = ref(null)
// 数据源
let dataSource = ref([])
// 选中
let selectedRowKeys = ref([])
let selectedRows = ref([])
// 广告总个数
let adTotal = ref(0)
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 1000,
  size: 'small',
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '集数',
    dataIndex: 'eq_number',
    key: 'eq_number',
  },
  {
    dataIndex: 'ad_type',
    key: 'ad_type',
  },
  {
    dataIndex: 'vid',
    key: 'vid',
  },
  {
    title: '完整版本',
    dataIndex: YoutubeVideoTypeObject.full,
    key: YoutubeVideoTypeObject.full,
  },
  {
    title: '无BGM版本',
    dataIndex: YoutubeVideoTypeObject.no_bgm,
    key: YoutubeVideoTypeObject.no_bgm,
  },
  {
    title: '无字幕版本',
    dataIndex: YoutubeVideoTypeObject.no_subtitle,
    key: YoutubeVideoTypeObject.no_subtitle,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 显示
function showDrawer (data) {
  // 清空
  selectedRowKeys.value = []
  selectedRows.value = []
  dataSource.value = [{}]
  // 记录
  detail.value = data
  // 显示
  visible.value = true
  // 延迟处理
  nextTick(() => {
    // 获取列表
    getYtVideoList()
  })
}

// 关闭
function onClose () {
  if (!isLoading.value && !isSyncAllLoading.value) {
    // 重置
    pagination.current = 1
    pagination.pageSize = 1000
    visible.value = false
  }
}

// 前台开关
function statusChange (e, record) {
  // isLoading.value = true
  const params = {
    lang_id: record.id,
    app_status: Number(e)
  }
  // langAppStatus(params).then(res => {
  //   const { code, data, msg } = res
  //   if (code === 0) {
  //     if (e) {
  //       message.success('开启成功')
  //     } else {
  //       message.success('关闭成功')
  //     }
  //   } else {
  //     message.error(res.message || msg)
  //   }
  //   getList()
  // }).catch(() => {
  //   getList()
  // })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getYtVideoList()
}

// 预览
function touchPreview (record, videoType) {
  RefPreviewModal.value.showModal({id: record.drama_id, eq: record.eq_number, videoType: videoType})
}

// 硬字幕生成字幕
function touchHardSubtitle () {
  console.log('硬字幕生成字幕')
  // 更新列表
  getYtVideoList()
}

// 点击批量上传
function touchBatchUpload () {
  // 清空
  batchUploadId.value = ''
  batchFileList.value = []
}

// 批量上传
function beforeUploadBatchPro (file, fileList, videoType) {
  // 每轮上传，都在首次处理文件列表
  if (file.uploadId != batchUploadId.value) {
    // 进入加载
    isLoading.value = true
    // 记录
    batchUploadId.value = file.uploadId
    // 取出所有文件名
    var eqs = []
    const isOK = fileList.every(item => {
      // 分割
      const names = item.name.split('.')
      // 取出0位置
      const eq = names[0]
      // 文件命名有问题
      if (!Pub.REG_IS_POSITIVE_INTEGER(eq)) {
        Modal.error({
          title: `【${item.name}】未匹配到剧集`,
          content: '请核实文件命名方式后再上传',
          okText: '好 的'
        })
        return false
      }
      // 检查文件类型
      if (!file.type.includes('video')) {
        Modal.error({
          title: `【${item.name}】非视频类型`,
          content: '请核实文件类型后再上传',
          okText: '好 的'
        })
        return false
      }
      // 文件集数是否大于总集数
      // if (Number(eq) > pagination.total) {
      if (Number(eq) > detail.value.total_ep) {
        Modal.error({
          title: `【${item.name}】大于剧集总集数`,
          content: '请核实文件命名方式后再上传',
          okText: '好 的'
        })
        return false
      }
      // 取出0位置
      eqs.push(eq)
      // 记录
      item.eq = eq
      // 返回
      return true
    })
    // 停止上传
    if (!isOK) {
      // 停止加载
      isLoading.value = false
      return false
    }
    // 转为数字数组
    eqs = eqs.map(Number)
    // 去重
    const repeatEqs = Array.from(new Set(eqs))
    // 是否数量一样
    if (repeatEqs.length !== eqs.length) {
      Modal.error({
        title: '部分剧集存在重复文件',
        content: '请核实文件命名方式后再上传',
        okText: '好 的'
      })
      // 停止加载
      isLoading.value = false
      return false
    }
    // 获取已存在剧集的集数
    ytExistVideo({ drama_id: detail.value.id, type: videoType }).then(res => {
      const { code, data } = res
      if (code === 0) {
        // 便利
        const exeqs = []
        data.forEach(item => {
          // 是否存在
          if (eqs.includes(item)) { exeqs.push(item) }
        })
        // 检查是否有以存在的剧集需要覆盖
        if (exeqs.length) {
          Modal.confirm({
            title: `${exeqs.join('、')}集已存在`,
            content: createVNode('div', { style: 'color: red;' }, '新视频将覆盖原视频，你还要继续吗？'),
            cancelText: '取 消',
            okText: '继 续',
            onOk () {
              // 开始上传
              batchUpload(fileList, videoType)
            },
            onCancel () {
              // 停止加载
              isLoading.value = false
            }
          })
        } else {
          // 开始上传
          batchUpload(fileList, videoType)
        }
      } else {
        // 停止加载
        isLoading.value = false
        message.error(message)
      }
    }).catch(err => {
      // 停止加载
      isLoading.value = false
      message.error(err.message)
    })
  }
  // 禁止上传
  return false
}

// 开始上传
function batchUpload (fileList, videoType) {
  // 总数量
  const total = fileList.length
  // 成功集数
  var seqs = []
  // 失败集数
  var feqs = []
  // 递归上传
  uploadFile(0, fileList, seqs, feqs, total, videoType)
}

// 递归上传
function uploadFile (index, fileList, seqs, feqs, total, videoType) {
  // 需要上传的问题
  const file = fileList[index]
  // 提示上传结果
  message.info(`正在上传【${file.name}】`)
  // 开始上传
  uploadCustom({ file, eq: file.eq }, (fileJson, res) => {
    // 上传结果判断
    if (fileJson.status === 'done') {
      // 上传成功
      const params = {
        drama_id: detail.value.id,
        eq_number: fileJson.eq,
        type: videoType,
        name: fileJson.name,
        url: fileJson.url,
        key: fileJson.key,
        duration: fileJson.duration,
        size: fileJson.size,
        preview_url: fileJson.url,
        vid: fileJson.vid,
        // size: res.res.size
      }
      ytVideoUpload(params).then(res => {
        const { code } = res
        if (code === 0) {
          // 提示上传结果
          message.success(`【${file.name}】上传成功，当前进度【${index + 1} / ${total}】`)
          // 记录成功
          seqs.push(fileJson.eq)
          // 刷新结果
          reloadBatchUploadResult(index, fileList, seqs, feqs, total, videoType)
        } else {
          // 提示上传结果
          message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
          // 记录失败
          feqs.push(fileJson.eq)
          // 刷新结果
          reloadBatchUploadResult(index, fileList, seqs, feqs, total, videoType)
        }
      }).catch(() => {
        // 提示上传结果
        message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
        // 记录失败
        feqs.push(fileJson.eq)
        // 刷新结果
        reloadBatchUploadResult(index, fileList, seqs, feqs, total, videoType)
      })
    } else if (fileJson.status === 'error') {
        // 提示上传结果
        message.error(`【${file.name}】上传失败，当前进度【${index + 1} / ${total}】`)
        // 记录失败
        feqs.push(fileJson.eq)
        // 刷新结果
        reloadBatchUploadResult(index, fileList, seqs, feqs, total, videoType)
    }
  }, Pub.BUCKET_YOUTUBE(), 'MediaManagementBatch')
}

// 刷新上传结果
function reloadBatchUploadResult (index, fileList, seqs, feqs, total, videoType) {
  // 上传完了，进行结算
  if (index === (total - 1)) {
    // 停止加载
    isLoading.value = false
    // 检查是否有失败的
    if (feqs.length) {
      // 有失败的
      Modal.error({
        title: '部分集数上传失败，请重新上传！',
        content: `${feqs.join('、')}`,
        okText: '好 的'
      })
    } else {
      // 没有失败的
      Modal.success({
        title: '上传成功！',
        okText: '好 的'
      })
      // 更新列表
      getYtVideoList()
    }
  } else {
    // 继续上传
    uploadFile(index + 1, fileList, seqs, feqs, total, videoType)
  }
}

// 准备上传
function beforeUploadPro (file) {
  if (!file.type.includes('video')) {
    message.error('请上传视频类型的文件')
    return false
  }
  isLoading.value = true
  return true
}

// 上传结果
function uploadResult (fileJson, res, record, videoType) {
  // 上传结果判断
  if (fileJson.status === 'done') {
    const params = {
      drama_id: record.drama_id,
      eq_number: record.eq_number,
      type: videoType,
      name: fileJson.name,
      url: fileJson.url,
      key: fileJson.key,
      duration: fileJson.duration,
      size: fileJson.size,
      preview_url: fileJson.url,
      vid: fileJson.vid,
      // size: res.res.size
    }
    ytVideoUpload(params).then(res => {
      isLoading.value = false
      const { code } = res
      if (code === 0) {
        // 成功
        if (record.id) {
          message.success('更新成功')
        } else {
          message.success('上传成功')
        }
        // 刷新列表
        getYtVideoList()
      } else {
        // 失败
        message.error(res.message)
      }
    }).catch(() => {
      // 失败
      if (record.id) {
        message.error('更新失败')
      } else {
        message.error('上传失败')
      }
    })
  } else if (fileJson.status === 'error') {
    isLoading.value = false
    if (record.id) {
      message.error('更新失败')
    } else {
      message.error('上传失败')
    }
  } else {
    // console.log('正在上传');
  }
}

// 获取列表
function getYtVideoList () {
  isLoading.value = true
  const params = {
    drama_id: detail.value.id,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  ytVideoList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      // 清空
      selectedRowKeys.value = []
      selectedRows.value = []
      // 重置列表数据
      dataSource.value = data.data
      pagination.total = data.total
      adTotal.value = data.ad_count
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 从APP片库导入
function touchImportFromApp () { 
  RefImportFromApp.value.showDrawer(detail.value)
}

// 音效文件
function touchSoundEffectConfig () {
  RefSoundEffectConfig.value.showModal(detail.value?.id)
}

// 抛出
defineExpose({
  showDrawer
})

</script>

<style scoped>
.tool-view {
  display: flex;
}
.table-view {
  margin-top: 20px;
}

/* 音效文件弹窗 */
.sound-effect-upload-hint {
  padding-top: 6px;
  color: #8d8d8d;
  font-size: 12px;
}
.sound-effect-upload-list {
  margin-top: 10px;
}
.sound-effect-upload-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.sound-effect-upload-item:last-child {
  border-bottom: none;
}
.sound-effect-upload-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sound-effect-upload-status {
  color: #1890ff;
  font-size: 12px;
}
.sound-effect-upload-action {
  margin-left: 8px;
  font-size: 12px;
}
</style>